import "../../i18nFallback";
import { Sentry } from "../../sentryInstrumentReact";
import React from 'react';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import axios from 'axios';


// pre-set value if results of form error
let stationString = document.querySelector('fieldset.radio').dataset['customStation'] || null;

// translated text
const loadingText = gettext("Loading...");
const searchText = gettext("Search for your radio station.");
const labelText = gettext("Which Station?");
const noResultsText = gettext("No results");


function StationAutoComplete() {
  const [stations, setStations] = React.useState([]);


  React.useEffect( () => {

    async function fetchStations() {
      try {
        const response = await axios.get("/donate/radio-stations-for-state-secure/");
        const formattedStations = await response.data.map((item) => {
          let outputString = `${item.station} ${item.dial}, ${item.city}`; 
          if (item.name !== '') {
            outputString += ` - ${item.name}`;
          }
          return ({
            id: item.id,
            name: outputString,
            code: item.media_code,
          });
        }); 
        setStations(formattedStations);
      } catch (error) {
		if (Sentry && Sentry.getClient()) {
          Sentry.captureException(error, {stage: "error fetching station data"});
		}
      }
    }
    
    fetchStations();

  }, []);
  

  const handleOnSearch = (string, results) => {
    //console.log(string, results)
  }

  const handleOnSelect = (item) => {
	  document.querySelector("input[name=where_do_you_listen_1]").value = item.code;
  }

  const formatResult = (item) => {
    return (
      <>
        <span style={{ display: 'block', textAlign: 'left' }}>{item.name}</span>
      </>
    )
  }

  return (
    <>
      <div className="form-group">
        <label className="select-label active station-search-label">{searchText}</label>
        <ReactSearchAutocomplete
          items={stations}
          onSearch={handleOnSearch}
		      onSelect={handleOnSelect}
          showNoResultsText={noResultsText}
          showIcon={false}
          formatResult={formatResult}
          inputSearchString={stationString !== null ? stationString : '' }
          placeholder={stations.length === 0 ? loadingText : '' }
          styling={{
            height: "58px",
            zIndex: "100",
            border: "2px solid #EEE",
            borderRadius: "var(--border-radius)",
            backgroundColor: "var(--body-color)",
            boxShadow: "inset 0 1px 1px rgba(0,0,0,.075)",
            hoverBackgroundColor: "var(--body-bg-alt)",
            outline: "2px solid rgba(var(--form-outline-color), 1)",
            color: "var(--text-color)",
            fontSize: "1.2rem",
            fontFamily: "var(--sans)",
            iconColor: "var(--muted-text)",
            lineColor: "rgb(232, 234, 237)",
            placeholderColor: "var(--muted-text)",
            paddingLeft: 30,
            clearIconMargin: '10px 10px 0 0',
            searchIconMargin: '0 0 0 16px',
            marginBottom: '5px',
          }}
        />
      </div>
    </>
  );
}

export default StationAutoComplete;
